import { render, staticRenderFns } from "./me.vue?vue&type=template&id=ba6207fc"
import script from "./me.vue?vue&type=script&lang=js"
export * from "./me.vue?vue&type=script&lang=js"
import style0 from "./me.vue?vue&type=style&index=0&id=ba6207fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports